










































































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataDokter from "@/services/DataUtility";
import DataRujukan from "@/services/DataRujukan";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeJawabanRujukan } from "@/store/modules/jawabanrujukan";
import { storeSoap } from "@/store/modules/soap";
import moment from "moment";
import DataUtility from "@/services/DataUtility";
import { resepStore } from "@/store/modules/resep";
@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalJawabanRujukan extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() dataJawabanRujukan!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }
  // faskesLainnya = "";
  faskesLainnya = "";
  searchFaskes = null;
  disFaskes = false;
  check = false;
  autofocus = false;
  dokter_tujuan = "";
  diagnosis = "";
  terapi = "";
  saran = "";
  tglSurat = "";
  faskes = {};
  listFaskes = {};
  listFaskesBaru = [];
  sess_login = userModule.user;
  listDokter = {};
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  err = {};
  modalTtd = false;
  tglShowSurat = false;
  today = new Date().toISOString().substr(0, 10);
  dissableSunday = val => ![0].includes(new Date(val).getDay());
  idFaskes = "";
  _timerId;
  loading = false;
  stateRtl = [];

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  get stateJawabanRujukan() {
    return storeJawabanRujukan.jawabanRujukan;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get soapRegister() {
    return this.statesoapdetail.filter(
      item => String(item.register_id) === String(this.register)
    );
  }

  get resepList() {
    return resepStore.resep;
  }

  get resepRegister() {
    return this.resepList.filter(
      item => String(item.register_id) === String(this.register)
    );
  }

  get resepExisting() {
    return this.resepRegister.filter(
      item => item.dokter?.id == userModule.user?.id
    );
  }

  get terapiTextDefault() {
    return this.resepExisting.map(item => item.text).join("\r\n");
  }

  mounted() {
    this.getDpjp();
    this.faskesList();
  }

  faskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.listFaskes = faskes;
      // console.log("faskes", this.listFaskes);
    });
  }

  // faskesBaruList() {
  //   const dt = DataRujukan.getDataFaskesCustom(this.searchFaskes);
  //   dt.then((dt) => {
  //     this.stateRtl = dt;
  //     console.log("faskes custom", this.stateRtl);
  //   });
  // }

  @Watch("dataJawabanRujukan")
  getJawabanRujukan() {
    if (this.dataJawabanRujukan["dokter"] == undefined) {
      this.tglSurat = this.today;
      this.dokter_tujuan = "";
      this.faskes = {};
      this.diagnosis = this.soapRegister.length
        ? this.soapRegister[0].a || ""
        : "";
      this.terapi = this.terapiTextDefault;
      this.saran = "";
      this.muatResepRegister();
    } else {
      this.tglSurat = this.dataJawabanRujukan["tgl_surat"];
      this.dokter_tujuan = this.dataJawabanRujukan["dokter_tujuan"];
      // this.faskes = this.dataJawabanRujukan["faskes_tujuan"];
      this.diagnosis = this.dataJawabanRujukan["diagnosis"];
      this.terapi = this.dataJawabanRujukan["terapi"];
      this.saran = this.dataJawabanRujukan["saran"];
      this.cekIdFaskes(this.dataJawabanRujukan["faskes_tujuan"]);
    }
  }

  async muatResepRegister() {
    const reg = this.register;
    if (!reg) return;

    await Promise.resolve(resepStore.getResepByRegister(reg)).catch(
      () => undefined
    );

    if (reg !== this.register) return;
    if (this.dataJawabanRujukan["dokter"] != undefined) return;
    if (this.terapi) return;

    this.terapi = this.terapiTextDefault;
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtd = false;
  }

  getDpjp() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }

  simpanJawabanRujukan() {
    if (this.readOnly) return;
    // console.log("sasasa ", this.faskesLainnya);
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      appModule.setLoading(true);
      let id = "";
      let nama = "";
      if (this.check == false) {
        id = this.faskes["id"];
        nama = this.faskes["nama"];
      } else {
        // console.log("fas-", this.faskesLainnya);
        // if (this.idFaskes != "") {
        //   id = this.idFaskes;
        // } else {
        //   id = "#";
        // }
        if (this.faskesLainnya["id"] != undefined) {
          id = this.faskesLainnya["id"];
          nama = this.faskesLainnya["nama"];
        } else {
          id = "#";
          nama = this.faskesLainnya;
        }
        // id = null;
        // nama = this.faskesLainnya;
        // nama = this.faskesLainnya.nama;
      }

      // console.log("kirim ", id, " ", nama);
      if (id == undefined || (id == null && nama == "")) {
        appModule.sendErrorAlert("Faskes Tujuan Harus diisi");
      } else {
        if (this.dataJawabanRujukan["dokter"] == undefined) {
          // console.log("Simpan", this.faskesLainnya);
          const dt = DataRujukan.saveDataJawabanRujukan(
            this.tglSurat,
            this.register,
            this.rm,
            this.sess_login["id"],
            this.dokter_tujuan,
            // this.faskes["id"],
            id,
            nama,
            this.diagnosis,
            this.terapi,
            this.saran
          );
          dt.then(dt => {
            appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
              this.modalTtd = true;
              this.show = false;
              appModule.NoticeDelay("Berhasil Simpan Surat Jawaban Rujukan");
              // this.faskesBaruList();
            }
          });
        } else {
          // console.log("Edit", id, " ---  ", nama);
          const dt = DataRujukan.editDataJawabanRujukan(
            this.dataJawabanRujukan["id"],
            this.tglSurat,
            this.register,
            this.rm,
            this.sess_login["id"],
            this.dokter_tujuan,
            // this.faskes["id"],
            id,
            nama,
            this.diagnosis,
            this.terapi,
            this.saran
          );
          dt.then(dt => {
            appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
              this.modalTtd = true;
              this.show = false;
              appModule.NoticeDelay("Berhasil Ubah Surat Jawaban Rujukan");
              // this.faskesBaruList();
            }
          });
        }
      }
    }
  }

  close() {
    storeJawabanRujukan.actJawabanRujukan_on_reg(this.register);
    this.show = false;
  }

  get tglRujukanFormattedMomentjs() {
    return this.tglSurat ? moment(this.tglSurat).format("DD MMMM YYYY") : "";
  }
  klikCheck() {
    if (this.check == false) {
      // alert("faskes");
      // this.faskesLainnya = {
      //   id: "#",
      //   nama: "",
      // };
      this.faskesLainnya = "";
      this.disFaskes = false;
      // this.idFaskes = "";
    } else {
      this.autofocus = true;
      this.faskes = {};
      // alert("lainnya");
      this.disFaskes = true;
    }
  }
  cekIdFaskes(val) {
    const typeId = val["id"].substr(0, 1);
    // console.log("tipe", val);
    if (typeId == "#") {
      this.check = true;
      this.autofocus = true;
      this.faskes = {};
      this.disFaskes = true;
      this.faskesLainnya = val;
      // this.faskesLainnya = val["nama"];
      this.idFaskes = val["id"];
    } else {
      this.check = false;
      // this.faskesLainnya = {
      //   id: "#",
      //   nama: "",
      // };
      this.faskesLainnya = "";
      this.disFaskes = false;
      this.faskes = val;
    }
    // this.faskes = val
  }

  // get stateRtl() {
  //   return storeJawabanRujukan.faskesCustom;
  // }
  @Watch("searchFaskes", { deep: true })
  searchedFaskes() {
    this.listFaskesBaru = [];

    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (
        this.searchFaskes === null ||
        this.searchFaskes.length < 2 ||
        this.faskesLainnya === this.searchFaskes
      )
        return;
      this.loading = true;

      const dt = DataRujukan.getDataFaskesCustom(this.searchFaskes);
      dt.then(dt => {
        // this.stateRtl = dt;
        // console.log("faskes custom", this.stateRtl);

        this.listFaskesBaru = dt.map(faskesLainnya => {
          // console.log("alasan", faskesLainnya);
          return faskesLainnya;
        });
        if (!dt.length) {
          this.faskesLainnya = this.searchFaskes;
        }
      })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => (this.loading = false));
    }, 500);
  }
  // @Watch("faskesLainnya")
  // selectOption(val) {
  //   console.log("select", this.faskesLainnya);
  // }
}
